// extracted by mini-css-extract-plugin
export default {"searchBox":"SearchBox_searchBox__Lmcbi"};